'use client';

import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { EventService } from '@/shared/lib/event-service';
import { AmountInput } from '@/shared/ui/amount-input';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import './product-detail.scss';
import { ProductMenuNote } from './product-menu-note';
import { ProductDetailContext } from './provider';
import { useVisibleAddonSections } from './use-visible-addon-sections';

export const ProductDetailInfoAddToCart = () => {
    const t = useTranslations();
    const { hash, formMethods, currentItem, id } = useContext(ProductDetailContext);
    const quantity = useWatch({ control: formMethods.control, name: 'quantity' });
    const variant = useWatch({ control: formMethods.control, name: 'variant' });
    const note = useWatch({ control: formMethods.control, name: 'note' });

    const visibleSections = useVisibleAddonSections(currentItem);
    const hasAddons = visibleSections.length > 0;

    return (
        <>
            {!hasAddons && <ProductMenuNote className="product-detail__info-note" />}
            <div className="product-detail__info-add-to-cart">
                <AmountInput
                    value={quantity}
                    min={1}
                    data-testid="product-detail-quantity-input"
                    plusButtonProps={{
                        'data-testid': 'product-detail-quantity-increase',
                        onClick: () => {
                            formMethods.setValue('quantity', quantity + 1);
                        },
                    }}
                    minusButtonProps={{
                        'data-testid': 'product-detail-quantity-decrease',
                        onClick: () => {
                            const finalQuantity = quantity - 1;
                            if (finalQuantity < 1) {
                                return;
                            }
                            formMethods.setValue('quantity', finalQuantity);
                        },
                    }}
                />
                <Button
                    className="product-detail__info-add-to-cart-button"
                    onClick={() => {
                        if (hasAddons) {
                            EventService.trigger('product:addons-menu:view-detail', {
                                productHash: hash,
                                initialQuantity: quantity,
                                initialVariant: variant,
                            });
                        } else {
                            EventService.trigger('cart:product:add-to-cart', {
                                id,
                                productHash: hash,
                                quantity,
                                variant: variant as string,
                                note,
                            });
                        }
                    }}
                    data-testid="product-detail-add-to-cart-button"
                >
                    <Icon name="plus" width={24} height={24} />
                    <span data-testid="product-detail-add-to-cart-text">{t('WORDS.ADD_TO_CART')}</span>
                </Button>
            </div>
        </>
    );
};
